/* eslint-disable implicit-arrow-linebreak */
import { useQuery } from '@tanstack/react-query';
import BenefitsService from 'src/services/benefits.service';

// eslint-disable-next-line no-unused-vars
export const useBenefitTypeByVersionId = (params: { id: string }) => {
  const result = useQuery({
    queryKey: ['benefits/type'],
    queryFn: () => BenefitsService.getBenefitTypeByVersionId(params.id),
    enabled: true,
  });
  return result;
};
